/**
 * CardAsync ActionTypes
 */
export enum Actions {
  UPDATE_CARD_ASYNC_INPUT = "UPDATE_CARD_ASYNC_INPUT",
  SET_CARD_ASYNC_INPUT_DIRTY = "SET_CARD_ASYNC_INPUT_DIRTY",
  SWITCH_CARD_ASYNC_VALIDITY = "SWITCH_CARD_ASYNC_VALIDITY",
  SET_CARD_ASYNC_TOKEN = "SET_CARD_ASYNC_TOKEN",
  DISABLE_CARD_ASYNC_FORM = "DISABLE_CARD_ASYNC_FORM",
  ENABLE_CARD_ASYNC_FORM = "ENABLE_CARD_ASYNC_FORM",
  UPDATE_WEBPAY_SETTING = "UPDATE_WEBPAY_SETTING",
}



// WEBPACK FOOTER //
// ./src/containers/CardAsync/store/Actions.ts